export const comments_5150488 = {"data":{"data":[],"links":{}}}